import type { MantineStyleProp } from '@mantine/core';
import type { ReactNode } from 'react';
import { Box } from '@mantine/core';

interface ContentCardProps {
  children: ReactNode;
  style?: MantineStyleProp;
  visibleFrom?: string;
  hiddenFrom?: string;
}

export const ContentCard = ({ children, style, visibleFrom, hiddenFrom }: ContentCardProps) => (
  <Box
    visibleFrom={visibleFrom}
    hiddenFrom={hiddenFrom}
    style={[
      {
        width: '100%',
        borderRadius: 12,
        border: '1px solid var(--color-border-default)',
        backgroundColor: 'var(--color-bg-surface)',
        overflow: 'hidden'
      },
      style
    ]}
  >
    {children}
  </Box>
);
